<template>
  <component
    :is="iconComponent"
    role="img"
    :class="[iconSize, custom]"
    class="inline-block fill-current"
    v-bind="attributes"
  />
</template>

<script>
import icons from '@/components/icons/_requireIcons'
export default {
  name: 'base-icon',
  props: {
    name: {
      type: String,
      required: true,
      validator: function (value) {
        return Object.prototype.hasOwnProperty.call(icons, value)
      }
    },
    size: {
      type: String,
      default: 'md'
    },
    custom: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '',
    },
    ariaHidden: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    attributes () {
      let atrrs = {}
      if (this.title) {
        atrrs = {
          title: this.title,
          'aria-label': this.title,
        }
      }
      if (this.ariaHidden) {
        atrrs['aria-hidden'] = true
      }
      return atrrs
    },
    iconComponent: function () {
      return icons[this.name]
    },
    iconSize: function () {
      return {
        'w-2 h-2': this.size === 'tiny',
        'w-3 h-3': this.size === 'xs',
        'w-4 h-4': this.size === 'xsm',
        'w-5 h-5': this.size === 'sm',
        'w-6 h-6': this.size === 'md',
        'w-8 h-8': this.size === 'lg',
        'w-12 h-12': this.size === 'lg2',
        'w-16 h-16': this.size === 'xl',
        'w-20 h-20': this.size === '2xl',
      }
    }
  }
}
</script>
